import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import { milestoneSchema } from "../../../Validation/Validation";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";
import CodeEditor from "../../../Components/CodeEditor";

const AddMileStone = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    title: editData?.title || "",
    image: editData?.image,
    year: editData?.year || "",
    description: editData?.description || "",
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? true,
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: milestoneSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {

        const response = editingId ? await axiosInstance.put(`/milestone/updateMilestone/${editingId}`, values,
        ) : await axiosInstance.post("/milestone/createMilestone", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/milestones");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Milestones", path: "/milestones" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Milestone
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="client-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control  `}
                        id="client-sortOrder"
                        name="sortOrder"
                        placeholder="Enter client Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="milestone-title"
                        className="col-form-label "
                      >
                        Milestone Title
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control  `}
                        id="milestone-title"
                        name="title"
                        placeholder="Enter milestone title"
                        value={values.title || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.title && errors.title && (
                        <small className="text-danger">{errors.title}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="milestone-year"
                        className="col-form-label "
                      >
                        Milestone Year
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control  `}
                        id="milestone-year"
                        name="year"
                        placeholder="Enter milestone year"
                        value={values.year || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.year && errors.year && (
                        <small className="text-danger">{errors.year}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="milestone-description"
                        className="col-form-label "
                      >
                        Milestone Description
                      </label>

                      <CodeEditor
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                      />

                      {touched.description && errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mt-5">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/milestones">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMileStone;
